// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-timer[data-v-459ed078]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center}.timer-svg[data-v-459ed078]{width:100%;height:100%;transform:rotate(-90deg)}.timer-circle-bg[data-v-459ed078]{fill:none}.timer-circle[data-v-459ed078]{fill:none;stroke-linecap:round}", ""]);
// Exports
module.exports = exports;
